import {map, reduce} from '../lang/array';
import {isString} from '../lang/is';

const
    alphabet = (
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
        .split('')),

    lookup = (
        reduce(
            alphabet,
            (lookup, character, i) => {
                lookup[character] = i;
                return lookup;
            },
            {'=': 0})),

    encode = string => {
        const
            characters = (
                isString(string) ?
                    map(unescape(
                            encodeURIComponent(
                                string))
                        .split(''),
                        character => character.charCodeAt(0)) :
                    string),
            {length} = characters,
            output = [];
        let encoding = 0;

        for (let i = 0; i < length; i += 3) {
            encoding = (
                (characters[i] << 16) +
                ((i + 1) < length ?
                    (characters[i + 1] << 8) :
                    0) +
                ((i + 2) < length ?
                    characters[i + 2] :
                    0));
            output.push(alphabet[0x3f & (encoding >> 18)]);
            output.push(alphabet[0x3f & (encoding >> 12)]);
            if ((i + 1) < length) {
                output.push(alphabet[0x3f & (encoding >> 6)]);
            }
            if ((i + 2) < length) {
                output.push(alphabet[0x3f & encoding]);
            }
        }
        return output.join('');
    },

    bytes = string => {
        const
            characters = string.split(''),
            {length} = string,
            output = [];
        let decoding = 0;

        for (let i = 0; i < length; i += 4) {
            decoding = (
                (lookup[characters[i]] << 18) +
                ((i + 1) < length ?
                    (lookup[characters[i + 1]] << 12) :
                    0) +
                ((i + 2) < length ?
                    (lookup[characters[i + 2]] << 6) :
                    0) +
                ((i + 3) < length ?
                    lookup[characters[i + 3]] :
                    0));
            output.push(0xff & (decoding >> 16));
            if ((i + 3) < length && characters[i + 3] !== '=') {
                output.push(0xff & (decoding >> 8));
                output.push(0xff & decoding);
            } else if ((i + 2) < length && characters[i + 2] !== '=') {
                output.push(0xff & (decoding >> 8));
                if ((0x3 & lookup[characters[i + 2]]) !== 0) {
                    output.push(0xff & decoding);
                }
            } else if ((i + 1) < length && characters[i + 1] != '=') {
                if ((0xf & lookup[characters[i + 1]]) !== 0) {
                    output.push(0xff & (decoding >> 8));
                }
            }
        }
        return output;
    },

    decode = string => (
        decodeURIComponent(
            escape(
                String.fromCharCode(
                    ...bytes(string)))));

export {
    encode,
    decode,
    bytes
};
